/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Label, Button, Alert, InputGroup,
} from 'reactstrap';

import { useHistory } from 'react-router-dom';

import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../../helpers/api_helper';
import * as urls from '../../../helpers/url_helper';

function SmtpTestForm(props) {
  const { actionUrl } = props;
  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const [url, setActionUrl] = useState(actionUrl);
  const [loading, setLoading] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const user = JSON.parse(localStorage.getItem('authUser'));

  const send = async (values) => {
    try {
      setLoading(true);
      const result = await post(url, values);
      setErrorMessage(null);
      setSuccessFlag(true);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
      setSuccessFlag(false);
    } finally {
      setLoading(false);
    }
  };

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const ValidationSchema = Yup.object().shape({
    to_email: Yup.string()
      .email('Invalid email address format')
      .required('To: Email is required'),
    from_email: Yup.string()
      .email('Invalid email address format')
      .required('From: Email is required'),
  });

  const jsx = (
    <>
      <Alert color="success" className="mt-3" isOpen={(successFlag)}>
        Message sent successfully
      </Alert>
      { em }
      <Formik
        enableReinitialize
        initialValues={{
          to_email: user.email,
          from_email: user.email,
        }}
        // eslint-disable-next-line no-undef
        validationSchema={ValidationSchema}
        onSubmit={(values, actions) => {
          send(values);
        }}
      >
        {({
          touched, setFieldValue, errors, values, field,
        }) => (
          <Form className="row row-cols-lg-auto g-3 align-items-center" autoComplete="off">
            <Col xs={12}>
              <InputGroup>
                <div className="input-group-text">To:</div>
                <Field
                  type="text"
                  className={`form-control ${(errors.to_email && touched.to_email ? 'is-invalid' : '')}`}
                  name="to_email"
                />
              </InputGroup>
            </Col>

            <Col xs={12}>
              <InputGroup>
                <div className="input-group-text">From:</div>
                <Field
                  type="text"
                  className={`form-control ${(errors.from_email && touched.from_email ? 'is-invalid' : '')}`}
                  name="from_email"
                />
              </InputGroup>
            </Col>

            <Col xs={12}>
              <button type="submit" disabled={loading} className="btn btn-danger w-md">Send</button>
            </Col>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

SmtpTestForm.defaultProps = {

};

SmtpTestForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
};

export default SmtpTestForm;
